export default __webpack_public_path__ + "a0266d01d6e1ee21e474df2ec81368f3.png";